import script from "./trademarks.vue?vue&type=script&setup=true&lang=ts"
export * from "./trademarks.vue?vue&type=script&setup=true&lang=ts"

import "./trademarks.vue?vue&type=style&index=0&id=334ba854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334ba854"]])

export default __exports__